<template>
  <div>
    <v-row justify="end" class="mb-2">
      <v-col cols="6" md="3" lg="2">
        <v-btn
          v-if="!readonly"
          block
          color="primary"
          @click="addCandidate"
        >
          Add Candidate +
        </v-btn>
      </v-col>
    </v-row>
    <v-form ref="multipleCandidatesForm">
      <v-card
        v-for="candidate in candidates"
        :key="candidate.id"
        outlined
        class="mb-2"
      >
        <v-card-text>
          <div style="display: flex;">
            <div style="width: 90%">
              <DealSingleCandidate
                ref="singleCandidateForms"
                :sm="true"
                :candidate="candidate"
                :readonly="readonly"
                v-on="forwardEvents"
              />
            </div>
            <div style="width: 10%; align-items: center; align-content: center;" class="px-1">
              <v-btn
                v-if="!readonly"
                class="mx-1 my-1"
                color="red"
                outlined
                block
                style="height: 80% !important;"
                @click="deleteCandidate(candidate.id)"
              >
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-form>
    <ConfirmationModal
      :title="'Delete Confirmation'"
      :contentText="'Are you sure you want to delete this candidate?'"
      :toolbarColor="'primary'"
      :showModal="showDeleteConfirmationDialog"
      @cancel-click="() => {
        this.showDeleteConfirmationDialog = false
        this.candidateIdToDelete = null
      }"
      @ok-click="confirmDelete"
    ></ConfirmationModal>
  </div>
</template>

<script>
import DealSingleCandidate from './DealSingleCandidate.vue'
import { ConfirmationModal } from '@/components/dialogs'

export default {
  name: 'DealMultipleCandidates',

  components: {
    DealSingleCandidate: DealSingleCandidate,
    ConfirmationModal
  },

  props: [
    'candidates',
    'readonly'
  ],

  data () {
    return {
      showDeleteConfirmationDialog: false,
      candidateIdToDelete: null
    }
  },

  computed: {
    forwardEvents () {
      var vm = this

      return {
        setFirstName: function () {
          vm.$emit('setFirstName', arguments[0], arguments[1])
        },
        setLastName: function () {
          vm.$emit('setLastName', arguments[0], arguments[1])
        },
        setEmailAddress: function () {
          vm.$emit('setEmailAddress', arguments[0], arguments[1])
        },
        setCandidateTypeId: function () {
          vm.$emit('setCandidateTypeId', arguments[0], arguments[1])
        },
        setExistingCandidateId: function () {
          vm.$emit('setExistingCandidateId', arguments[0], arguments[1])
        }
      }
    }
  },

  methods: {
    addCandidate () {
      this.$emit('addCandidate')
    },
    deleteCandidate (dealCandidateId) {
      this.candidateIdToDelete = dealCandidateId
      this.showDeleteConfirmationDialog = true
    },
    confirmDelete () {
      this.$emit('deleteCandidate', this.candidateIdToDelete)
      this.showDeleteConfirmationDialog = false
      this.candidateIdToDelete = null
    },
    areCandidatesValid () {
      const isParentFormValid = this.$refs.multipleCandidatesForm
        ? this.$refs.multipleCandidatesForm.validate()
        : true

      const candidateForms = this.$refs.singleCandidateForms || []
      const areChildFormsValid = candidateForms.every(candidateForm => {
        return candidateForm && typeof candidateForm.isCandidateValid === 'function'
          ? candidateForm.isCandidateValid() === true
          : true
      })

      return isParentFormValid && areChildFormsValid
        ? true
        : 'Please fill out the required fields to proceed'
    }
  }
}
</script>
